module.exports = __webpack_public_path__ + "img/card.f7683c92.svg";